import { mergeClassNames } from '../../../../../utils/commonFunctions';
import { DropdownArrow } from '../../../../CommonComponents/svgs/Svgs';
import './StepperDropdown.scss'

import { FC, HTMLAttributes } from "react";

interface DropdownContainerProps extends HTMLAttributes<HTMLDetailsElement> {
    className?: string;
    disabled?: boolean;
    open: boolean
    children: React.ReactNode;
}

interface HeaderProps extends HTMLAttributes<HTMLDivElement> {
    title: string;
    className?: string;
    marker?: React.ReactNode;
    children: React.ReactNode;
    onToggle: () => void;
}

interface ComponentProps extends HTMLAttributes<HTMLDivElement> {
    className?: string;
    marker?: React.ReactNode;
    children: React.ReactNode;
}

export const StepperDropdownContainer: FC<DropdownContainerProps> = ({ className = '', children, disabled, open, ...props }) => {
    return (
        <details className={mergeClassNames(`scenario__stepper__dropdown__container ${disabled && 'disabled'}`, className)} open={open} {...props}
            {...(disabled && { onClick: (e) => e.preventDefault() })}
        >
            {children}
        </details>
    )
}
export const StepperDropdownHeader: FC<HeaderProps> = ({ className = '', children, onToggle, marker, ...props }) => {
    return (
        <summary className={mergeClassNames('stepper__dropdown__header', className)} {...props}
            onClick={(e) => {
                e.preventDefault()
                onToggle()
            }}
        >
            <div className="stepper__dropdown__header__marker">{marker || <DropdownArrow />}</div>
            <div className='stepper__dropdown__header__details__container'>
                {children}
            </div>
        </summary>
    )
}


export const StepperDropdownHeaderTitle: FC<ComponentProps> = ({ className = '', children, ...props }) => {
    return (
        <div className={mergeClassNames('stepper__dropdown__header__title', className)} {...props}>
            {children}
        </div>
    )
}
export const StepperDropdownHeaderIcon: FC<ComponentProps & { show?: boolean }> = ({ className = '', show = true, children, ...props }) => {
    if (!show) return null
    return (
        <div className={mergeClassNames('stepper__dropdown__header__icon', className)} {...props}>
            {children}
        </div>
    )
}

export const StepperDropdownContent: FC<ComponentProps> = ({ className = '', children, ...props }) => {
    return (
        <div className={mergeClassNames('stepper__dropdown__content', className)} {...props}>
            {children}
        </div>
    )
}
